import style from './02_pricingstudents.css'

import ico1 from '../../Images/money-bag.png'
import ico2 from '../../Images/money.png'
import ico3 from '../../Images/hundred-points.png'
import ico4 from '../../Images/coaching.png'

export default function PricingStudents() {
    return (
        <div style={{ backgroundColor: '#FFFDF4' }}>
            <div className='pricingstudentspage-main'>
                <h2>You Learn. They Earn.</h2>
                <p>SurSaathi connects students with great music teachers. Every lesson you book directly supports your teacher. When you contact a teacher through SurSaathi:</p>
            </div>
        </div>
    );
}
